// core
export { ImageCropperModule } from './src/imageCropperModule';
export { ImageCropperComponent } from './src/imageCropperComponent';
// extra classes
export { ImageCropper } from './src/imageCropper';
export { CropperSettings } from './src/cropperSettings';
export { CropperDrawSettings } from './src/cropperDrawSettings';
// models
export { Bounds } from './src/model/bounds';
export { CropPosition } from './src/model/cropPosition';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-img-cropper/index.js
// module id = ./node_modules/ng2-img-cropper/index.js
// module chunks = vendor